<template >
  <el-scrollbar class="noscroll-x" style="height: 100vh" v-if="!hidden">
    <div :class="['home']">
<!--      <nav :class="[scrolling?'scrolling':'']">-->
<!--        <div class="logo" @click="HandleLogoClick">-->
<!--          <img src="/static/img/home/logo.png" alt="" style="height: 40px;margin-top: 15px">-->
<!--        </div>-->
<!--        <div class="nav-menu">-->
<!--          <ul>-->
<!--            <li class="active"><a href="#introduce">公司概况</a> </li>-->
<!--            <li><a href="#case">案例介绍</a> </li>-->
<!--            <li><a href="#solution">解决方案</a> </li>-->
<!--            <li><a href="#product">产品介绍</a> </li>-->
<!--            <li> <a href="#footer">联系我们</a> </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </nav>-->

      <section class="section1">
        <div class="section-bg"></div>
        <div class="section-body">
          <div class="section-main">
            <h3 >拷客</h3>
            <p class="sub">是指把电脑、手机、PAD上感兴趣的信息收集起来，<br>实现自己和分享好友的信息备忘和碎片式阅读</p>
          </div>
        </div>
      </section>

      <section class="section2" id="introduce">
        <div class="section-title">
<!--          <h3 class="" >公司自2012年成立，<span class="text-primary">经营9年</span></h3>-->
<!--          <p>公司目前共有员工16人：管理人员3人，技术人员10名，产品人员1名，<br>市场人员1名，行政、人力、财务1名</p>-->
          <p>网页操作： 从内容源复制文本，到拷客网站粘帖；从拷客网站直接上传文件</p>
            <p>电脑客户端操作：选择要收集的文本或文件，按CTRL+C+C完成上传</p>
            <p>手机客户端操作：选择要收集的文本或文件，长按屏幕，在弹出的菜单中选择共享（或分享、发送等）完成上传</p>
        </div>
        <div class="container">
          <el-row style="width: 90%;margin: 0 auto" :gutter="30">
            <el-col :lg="8" :md="12">
              <div class="servers-item bg-light">
                <i class="icon-social-dropbox"></i>
                <p>多格式</p>
                <p class="content">格式文本、网页、图形、表格、音视频等</p>
<!--                <p>-->
<!--                  沟通洽谈客户近10000家-->
<!--                </p>-->
              </div>
              <!--<div class="servers-item-gutter"></div>-->
              <div class="tail"></div>
            </el-col>
            <el-col :lg="8" :md="12">
              <div class="servers-item bg-primary">
                <i class="icon-globe"></i>
                <p>多形态</p>
                <p class="content">文本、文件</p>
<!--                <p>-->
<!--                  用户数近200万-->
<!--                </p>-->
              </div>
              <div class="tail"></div>
            </el-col>
            <el-col :lg="8" :md="12">
              <div class="servers-item bg-light">
                <i class="icon-layers"></i>
                <p>多载体</p>
                <p class="content">WORD、EXCEL、邮件、QQ、网页、资源管理器等</p>
<!--                <p>-->
<!--                  互联网、移动互联网APP模块化生成平台技术-->
<!--                </p>-->
              </div>
              <!--<div class="servers-item-gutter"></div>-->
              <div class="tail"></div>
            </el-col>
          </el-row>
        </div>
      </section>

      <section class="section3" id="case">
        <div class="section-title" >
          <h3 class="">案例介绍</h3>
<!--          <p>you can do anything you want to achieve the effect by it.</p>-->
        </div>
        <div class="power-item-wrap">
          <div class="container">
            <el-row class="dis-flex">
              <el-col :lg="10" class="h-v-center">
                <div class="content">
                  <div class="content-title">手机客户端</div>
                  <div class="spliter-wrap">
                    <div class="spliter"></div>
                  </div>
                  <p class="introduce">通过拷客把手机上的照片、录音、录像、网页、短信、邮件等内容”收藏””分享”（有免费的短信提醒），好友对分享的内容评论或分享给其它好友
                    </p>
                </div>
              </el-col>
              <el-col :lg="14">
<!--                <img src="/static/img/home/img1.png" width="100%">-->
                <img src="/static/img/home/case1bak.png" style="width: 500px; height: 400px">
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="power-item-wrap">
          <div class="container">
            <el-row class="dis-flex">
              <el-col :lg="14">
                <!--<img src="/static/img/home/img2.png" width="100%">-->
                <img src="/static/img/home/case2bak.png" style="width: 600px;height: 350px">
              </el-col>
              <el-col :lg="10" class="h-v-center">
                <div class="content">
                  <div class="content-title">Web版</div>
                  <div class="spliter-wrap rotate">
                    <div class="spliter"></div>
                  </div>
                  <p class="introduce">如果用户不是智能机，可以使用web版，支持任何电脑和手机的操作系统、支持低端电脑和手机<br>
                    </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="power-item-wrap">
          <div class="container">
            <el-row class="dis-flex">
              <el-col :lg="10" class="h-v-center">
                <div class="content">
                  <div class="content-title">IPTV拷客是集浏览、收藏、分享为一体的一云多屏交互类应用</div>
                  <div class="spliter-wrap">
                    <div class="spliter"></div>
                  </div>
                  <p class="introduce">IPTV用户，可以通过IPTV拷客的手机、PC客户端，收藏自己喜欢的照片、音视频，然后在TV端浏览，同时也允许经过授权的好友通过IPTV拷客的PC客户端、手机客户端将富媒体信息分享给IPTV拷客用户。
                    </p>
                </div>
              </el-col>
              <el-col :lg="14">
                <!--<img src="/static/img/home/img2.png" width="100%">-->
                <img src="/static/img/home/case3bak.png" style="width: 600px;height: 350px">
              </el-col>
            </el-row>
          </div>
        </div>
      </section>

<!--      <section class="section2" id="solution">-->
<!--        <div class="section-title" >-->
<!--          <h3 class="">解决方案</h3>-->
<!--          <p>我们拥有完整一体化的解决方案，帮助企业解决各种疑难问题</p>-->
<!--        </div>-->
<!--        <div class="container">-->
<!--          <el-row style="width: 90%;margin: 0 auto" :gutter="30">-->
<!--            <el-col :lg="8" :md="12">-->
<!--              <div class="servers-item bg-light">-->
<!--                <i class="icon-social-dropbox"></i>-->
<!--                <p>服务客户</p>-->
<!--                <p class="content">产品电商：企业O2O后，实现线上电商，通过活动模块、资讯模块、在线客服模块、大转盘等营销工具模块，为老客户提供便捷服务与体验</p>-->
<!--                <p>-->
<!--                  链商：聚集海量企业的粉丝，粉丝中同时不乏需要赚取额外收入的人群，借助此部分人群的社交资源，结合我们的链商系统，将企业的产品，进行二次推荐，在销售业绩提高的同时，拓展了企业的销售渠道 ；-->
<!--                </p>-->
<!--              </div>-->
<!--              &lt;!&ndash;<div class="servers-item-gutter"></div>&ndash;&gt;-->
<!--              <div class="tail"></div>-->
<!--            </el-col>-->
<!--            <el-col :lg="8" :md="12">-->
<!--              <div class="servers-item bg-primary">-->
<!--                <i class="icon-globe"></i>-->
<!--                <p>独立品牌</p>-->
<!--                <p class="content">凭借企业的服务，借助我们的线上下单模块、线上选择服务人员模块、线上支付等功能模块</p>-->
<!--                <p>-->
<!--                  将传统的线下客户，迁移到线上来，客户每次访问、每笔订单在线上留痕，随着客户不断的增加，帮助企业快速建立品牌-->
<!--                </p>-->
<!--              </div>-->
<!--              <div class="tail"></div>-->
<!--            </el-col>-->
<!--            <el-col :lg="8" :md="12">-->
<!--              <div class="servers-item bg-light">-->
<!--                <i class="icon-layers"></i>-->
<!--                <p>人力储备</p>-->
<!--                <p class="content">通过我们的派单系统，将线上的订单分配给不同的服务人员，大大提高了服务人员的工作效率，降低企业经营成本</p>-->
<!--                <p>-->
<!--                  同时通过对一段时间的派单数据分析，帮助企业在做人力招聘提供数据佐证，无形中降低了由于人力过盛或者不足造成的企业经营风险；-->
<!--                </p>-->
<!--              </div>-->
<!--              &lt;!&ndash;<div class="servers-item-gutter"></div>&ndash;&gt;-->
<!--              <div class="tail"></div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </div>-->
<!--      </section>-->

<!--      <section class="section4" id="product">-->
<!--        <div class="container" >-->
<!--          <el-row >-->
<!--            <el-col class="v-center" style="height: 25rem">-->
<!--              <div style="width: 50%" >-->
<!--                <div class="w-title" >欢迎使用</div>-->
<!--                <div class="w-content">-->
<!--                  为客户量身策划、定制、研发移动互联网业务平台：APP（iOS、Android、WinPhone）；及Wap2.0和HTML5手机网站；为行业提供移动互联网整体解决方案。-->
<!--                </div>-->
<!--                <div class="start-btn" @click="start">开始使用</div>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </div>-->
<!--      </section>-->

<!--      <section class="section5">-->
<!--        <div class="section-title">-->
<!--          <h3 class="">平台介绍</h3>-->
<!--          <p>开发平台以模块化的方式瞬间构建企业，N个功能模块高度自由组合，<br>满足不同企业的不同移动营销需求</p>-->
<!--        </div>-->
<!--        <div class="container">-->
<!--          <div class="h-v-center steps-wrap">-->
<!--            <el-steps :active="activeStep">-->
<!--              <el-step v-for="(step,index) in steps" :icon="step.icon" @click.native="activeStep=index" :key="index"></el-step>-->
<!--            </el-steps>-->
<!--          </div>-->
<!--          <div class="step-tabs">-->
<!--            <div v-for="(step,index) in steps" v-show="index==activeStep" :key="index">-->
<!--              <div class="step-tab-header">{{step.title}}</div>-->
<!--              <div class="step-tab-content">{{step.content}}</div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </section>-->
      <footer class="h-v-center" id="footer">
<!--        <div class="start-btn" @click="start">开始使用</div>-->
<!--        <span>@Beijing msgcopy Technology Co.Ltd版权所有</span>-->
        <a href="https://beian.miit.gov.cn">京ICP备11038383号-1</a>
        <span>地址：北京市昌平区立汤路龙德紫金 326</span>
        <span>联系方式：13701171932</span>
      </footer>
    </div>
  </el-scrollbar>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name:'Home',
  data(){
    return {
      scrolling:false,
      activeStep:0,
      interval:false,
      steps:[
        {
          icon:'fa fa-database',
          title:'打包生成',
          content:'一键五端：安卓、IOS、手机网页、PC网站、安卓电视端',
        },
        {
          icon:'fa fa-area-chart',
          title:'录入和设置',
          content:'根据需要建立分类、添加商品、设置功能',
        },
        {
          icon:'fa fa-newspaper-o',
          title:'自定义UI',
          content:'动态的界面：首页、宣传页、中间过渡页\n' +
            '动态的导航：左栏、底栏、右栏\n' +
            '动态的列表样式：图文、卡片、文字、自定义\n' +
            '动态的内容展现模板：新闻、混排、电商、表单、视频、图集等等\n',
        },
        {
          icon:'fa fa-paper-plane-o',
          title:'权限设置',
          content:'登录权限——针对需要封闭的客户圈子提供登陆控制权限\n' +
            '查看权限——针对不同权限的客户提供不同能力，彰显VIP的特权\n' +
            '后台权限——针对不同连锁店，不同技能的人提供不同权限，便于整体管理',
        }
      ]
    }
  },
  computed:{
    hidden(){
      return this.global._PROJECT=='shdq';
    }
  },
  methods:{
    HandleLogoClick(){
      window.location.reload();
    },
    skip(url){
      location.href = url
    },
    handleScroll(e){
      const scrollTop=e.target.scrollTop;
      const vh=this.$el.querySelector('.el-scrollbar__wrap').clientHeight;
      if(scrollTop>0){
        this.scrolling=true
      }else{
        this.scrolling=false
      }
      if(scrollTop<=vh)
        this.$el.querySelector('.section-bg').style.transform='translateY(-'+e.target.scrollTop/6+'px)';
      if(scrollTop>this.$el.querySelector('.section5').offsetTop-vh){
        if(!this.interval){
          this.interval=this.getInterval();
        }
      }else{
        if(this.interval){
          clearInterval(this.interval);
          this.interval=false;
        }
      }
    },
    start(){
      this.$router.push({name:'Login'})
    },
    getInterval(){
      return setInterval(()=>{
        if(this.activeStep<3){
          this.activeStep++;
        }else{
          this.activeStep=0
        }
      },3000);
    }
  },
  mounted(){
    if(!this.hidden)
    this.$el.querySelector('.el-scrollbar__wrap').addEventListener('scroll',this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
$primary:#328fe4;

.home{
  width: 100%;
  color: #818898;
  background-color: #fff;
  line-height: 1.5;
  .container{
    overflow-y: initial;
    //overflow-y: scroll;
    background-color: transparent;
  }
  .el-col{
    position: relative;
  }
  h3{
    line-height: 1.2;
    font-weight: 400;
  }
  nav{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    line-height: 70px;
    color: #fff;
    z-index: 100;
    transition: all .2s;
    .logo{
      height: 70px;
      font-size: 30px;
      float: left;
      padding: 0 20px;
      font-weight: bold;
      cursor: pointer;
    }
    .nav-menu{
      float: right;
      height: 70px;
      font-size: 18px;
      margin-right: 30px;
      li{
        display: inline-block;
        cursor: pointer;
        padding: 0 5px;
        &.active{
          //color: $primary;
        }
      }
    }
    &.scrolling{
      background-color: #fff;
      color: rgba(0, 0, 0, 0.6);
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
      .logo{
        color: #333;
      }
    }
  }
  .section1{
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content:center;
    text-align: center;
    overflow: hidden;
    position: relative;
    color: #fff;
    .section-bg{
      background-image: url("/static/img/home/bg1.jpg");
      background-size: cover;
      background-position: center center;
      width: 100%;
      height: 130%;
      position: absolute;
      transform: translateY(0);
      transition:all .2s;
    }
    .section-body{
      position: relative;
    }
    .section-main{
      display: inline-block;
    }
    h3{
      font-size: 2.25rem;
      font-weight: 300;
      font-family: sans-serif;
      text-transform: capitalize;
      margin-bottom: 15px;
    }
    .sub{
      font-size: 1.4em;
    }
  }
  .section-title{
    margin-bottom: 2.5rem;
    text-align: center;
    color: #818898;
    h3{
      color: #1e2022;
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
      .text-primary{
        color: $primary;
      }
    }
  }
  .section2{
    /*height: 90vh;*/
    /*padding-top:20vh;*/
    /*padding-bottom: 20vh;*/
    padding: 10vh;
    color: #818898;
    font-size: 0.75rem;
    .servers-item-gutter{
      height: 2.4rem;
      &+.tail{
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik04NTMuODkzLDg2Ljk5OGMtMzguODU5LDAtNTguODExLTE2LjQ1NS03Ny45NTYtMzUuMDUxYzE4LjI5NS0xMC41MzYsNDAuODkxLTE4LjI3Niw3My4zNzgtMTguMjc2IGMzOC42ODUsMCw2NC4xMzIsMTIuNTY0LDg1LjQ4OSwyOC4zNDdDOTE2LjE5Miw3Mi4wMTIsOTAwLjgsODYuOTk4LDg1My44OTMsODYuOTk4eiBNNTI2LjI2NSw4MC45NDUgYy02LjUxNy0wLjU2Mi0xMy41OTktMC44NzktMjEuNDEtMC44NzljLTcwLjc5OSwwLTkxLjMzNywyNy4yMjktMTM0LjQzMywzNS42NjJjMTQuOTAxLDMuNzIsMzIuMTE4LDYuMDcsNTIuODk4LDYuMDcgQzQ3MC4xNzEsMTIxLjc5Nyw1MDAuMzQsMTAzLjQyMSw1MjYuMjY1LDgwLjk0NXoiIGZpbGwtb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNNjYzLjQ1OCwxMDkuNjcxYy02Ny4xMzcsMC04MC4zNDUtMjMuODI0LTEzNy4xOTMtMjguNzI2QzU2Ny4wODYsNDUuNTU1LDU5Ny4zODEsMCw2NjUuNjkxLDAgYzYxLjg1NywwLDg1LjM2OSwyNy43ODIsMTEwLjI0Niw1MS45NDdDNzM2Ljg4OCw3NC40MzQsNzE3LjQ1OSwxMDkuNjcxLDY2My40NTgsMTA5LjY3MXogTTIxNy42OCw5NC4xNjMgYzU1Ljk3MSwwLDYyLjUyNiwyNC4wMjYsMTI2LjMzNywyNC4wMjZjOS44NTgsMCwxOC41MDgtMC45MTYsMjYuNDA0LTIuNDYxYy01Ny4xODYtMTQuMjc4LTgwLjE3Ny00OC44MDgtMTM4LjY1OS00OC44MDggYy03Ny4wNjMsMC05OS45Niw0OC41NjktMTUxLjc1MSw0OC41NjljLTQwLjAwNiwwLTYwLjAwOC0xMi4yMDYtODAuMDExLTI5LjUwNnYxNi44MDZjMjAuMDAzLDEwLjg5MSw0MC4wMDUsMjEuNzgyLDgwLjAxMSwyMS43ODIgQzE2MC4wMTQsMTI0LjU3LDE1OC42MDgsOTQuMTYzLDIxNy42OCw5NC4xNjN6IE0xMjAwLjExMiw0Ni4yOTJjLTU3LjQ5MywwLTU2LjkzNSw0Ni41OTUtMTE1LjAxNSw0Ni41OTUgYy01My42MTIsMC01OS43NTUtMzkuNjE4LTExNS42MDItMzkuNjE4Yy0xNS4yNjcsMC0yNS4zODEsMy43NTEtMzQuNjksOC43NDljMzYuMDk2LDI2LjY3NSw2MC41MDMsNjIuNTUyLDExNy4zNDIsNjIuNTUyIGM2OS4yNDksMCw3NS45NTEtNDMuNTU5LDE0Ny45NjQtNDMuNTU5YzM5LjgwNCwwLDU5Ljk4NiwxMC45NDMsNzkuODg4LDIxLjc3N1Y4NS45ODIgQzEyNjAuMDk3LDY4Ljc3MSwxMjM5LjkxNiw0Ni4yOTIsMTIwMC4xMTIsNDYuMjkyeiIgZmlsbC1vcGFjaXR5PSIuNSIvPjxwYXRoIGQ9Ik0xMDUyLjE0NywxMjQuNTdjLTU2Ljg0LDAtODEuMjQ3LTM1Ljg3Ni0xMTcuMzQyLTYyLjU1MmMtMTguNjEzLDkuOTk0LTM0LjAwNSwyNC45OC04MC45MTIsMjQuOTggYy0zOC44NTksMC01OC44MTEtMTYuNDU1LTc3Ljk1Ni0zNS4wNTFjLTM5LjA1LDIyLjQ4Ny01OC40NzksNTcuNzI0LTExMi40OCw1Ny43MjRjLTY3LjEzNywwLTgwLjM0NS0yMy44MjQtMTM3LjE5My0yOC43MjYgYy0yNS45MjUsMjIuNDc1LTU2LjA5Myw0MC44NTItMTAyLjk0Niw0MC44NTJjLTIwLjc3OSwwLTM3Ljk5Ni0yLjM0OS01Mi44OTgtNi4wN2MtNy44OTUsMS41NDUtMTYuNTQ2LDIuNDYxLTI2LjQwNCwyLjQ2MSBjLTYzLjgxMSwwLTcwLjM2Ni0yNC4wMjYtMTI2LjMzNy0yNC4wMjZjLTU5LjA3MiwwLTU3LjY2NSwzMC40MDctMTM3LjY2OSwzMC40MDdjLTQwLjAwNiwwLTYwLjAwOC0xMC44OTEtODAuMDExLTIxLjc4MlYxNDBoMTI4MCB2LTM3LjIxMmMtMTkuOTAzLTEwLjgzNS00MC4wODQtMjEuNzc3LTc5Ljg4OC0yMS43NzdDMTEyOC4wOTgsODEuMDExLDExMjEuMzk3LDEyNC41NywxMDUyLjE0NywxMjQuNTd6Ii8+PC9nPjwvc3ZnPg==);
      }
    }
    .tail{
      height: 100px;
      position: absolute;
      width: 100%;
      bottom: 0;
      pointer-events: none;
      background-repeat-y: no-repeat;
      background-size: 100% 100px;
    }
    .servers-item{
      padding: 2rem;
      border-radius: .25rem;
      position: relative;
      padding-bottom: 4.4rem;
      &+.tail{
        background-image: url("data:image/svg+xml;base64,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");
      }
    }
    i{
      font-size: 3rem;
      font-weight: 500;
      color: $primary;
      margin-bottom: 0.75rem;
      display: inline-block;
    }
    p{
      margin-bottom: 0.75rem;
      font-size: 0.75rem;
      &.content{
        font-size: 1rem;
        color: #1e2022;
      }
    }
  }
  .section3{
    /*padding-top:20vh;*/
    /*padding-bottom: 20vh;*/
    padding-top: 10vh;
    color: #313842;
    background-color: #f8f8f8;
    .power-item-wrap{
      padding: 10vh;
      &:nth-child(2){
        padding-top: 0;
      }
      &:nth-child(3){
        background-color: #fff;
        .content{
          text-align: right;
        }
        .spliter-wrap{
          transform: rotateY(180deg);
        }
      }
    }

    .content{
      width: 75%;
      .content-title{
        font-size: 24px;
        margin-bottom: 20px;
        font-weight: bold;
      }
      .introduce{
        font-size: .9rem;
      }
    }

    .spliter{
      height: 3px;
      width: 120px;
      margin-bottom: 30px;
      background: url("/static/img/home/spliter.svg") no-repeat center;
      background-size: cover;
    }
  }
  .section4{
    height: 25rem;
    position: relative;
    background-image: url("/static/img/home/bg2.jpg");
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    color: #fff;
    .container:before{
      content: '';
      display: inline;
      background-color: #191919;
      opacity: .3;
      position: relative;
      left: 0;
      width: 50%;
      height: 100%;
    }
    &:before{
      content:'';
      display: block;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0wIDE0MGgxMjgwQzU3My4wOCAxNDAgMCAwIDAgMHoiIGZpbGwtb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNMCAxNDBoMTI4MEM1NzMuMDggMTQwIDAgMzAgMCAzMHoiIGZpbGwtb3BhY2l0eT0iLjUiLz48cGF0aCBkPSJNMCAxNDBoMTI4MEM1NzMuMDggMTQwIDAgNjAgMCA2MHoiLz48L2c+PC9zdmc+);
      background-size: 100% 100px;
      transform: rotate(180deg);
      height: 100px;
      width: 100%;
      z-index: 1;
      position: absolute;
      top: -1px;
    }
    &:after{
      content:'';
      display: block;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0wIDE0MGgxMjgwQzU3My4wOCAxNDAgMCAwIDAgMHoiIGZpbGwtb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNMCAxNDBoMTI4MEM1NzMuMDggMTQwIDAgMzAgMCAzMHoiIGZpbGwtb3BhY2l0eT0iLjUiLz48cGF0aCBkPSJNMCAxNDBoMTI4MEM1NzMuMDggMTQwIDAgNjAgMCA2MHoiLz48L2c+PC9zdmc+);
      background-size: 100% 100px;
      /*transform: rotate(180deg);*/
      height: 100px;
      width: 100%;
      z-index: 1;
      position: absolute;
      bottom: -1px;
    }
    .w-title{
      /*text-align: center;*/
      font-size: 2rem;
      font-weight: bold;
      margin-bottom: 1rem;
    }
    .w-content{
      font-size: 0.8rem;
    }
  }
  .section5{
    padding: 10vh 0;
    min-height:calc(80vh - 70px);
    .steps-wrap{
      height: 120px;
      &>div{
        width: 50%;
      }
    }
    .step-tabs{
      width: 50%;
      margin: 20px auto;
      text-align: center;
      .step-tab-header{
        font-size: 1.5rem;
        margin-bottom: 15px;
        color: #333;
      }
      .step-tab-content{
        font-size: 0.9rem;
      }
    }
  }
  .link {
    overflow-y: scroll;
    height: 200px;
    font-size: 14px;
  }
  footer{
    //height:20vh;
    //background-color: $primary;
    background-color: #eff4fa;
    //position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    color: #b6b6d6;
    clear: both;
    line-height: 36px;
    text-align: center;
    border-top: 1px solid #d6dfea;
    font-size: 12px;
    color: #2c3e50;
    a{
      cursor: pointer;
    }
  }
}
.start-btn{
  padding: 12px 16px;
  display: inline-block;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  transition:all .2s;
  color: #fff;
  cursor: pointer;
  &:hover{
    color:#333;
    background:#fff;
  }
  border: 1px solid #fff {
    radius:3px;
  }
}
.contact {
  padding: 12px 16px;
  display: inline-block;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  transition:all .2s;
  color: #fff;
  cursor: pointer;
  &:hover{
    color:#333;
    background:#fff;
  }
  border: 1px solid #fff {
    radius:3px;
  }
}
.dis-flex{
  display: flex;
}
.h-v-center{
  display: flex;
  //text-align: justify;
  justify-content: space-around;
  align-items: center;
}
.v-center{
  display: flex;
  align-items: center;
}
.bg-light{
  background-color: #f6f9fc;
}
.bg-primary{
  background-color: $primary;
  *{
    color: #fff!important;
  }
}
</style>

<style lang="scss">
$primary:#328fe4;
$line:#E6E6E6;
@mixin active{
  //background: $primary;
  //color: #fff;
}
.home{
  .el-step__icon{
    height: 100px;
    width: 100px;
    border: 1px solid #E6E6E6;
    position: absolute;
    top: -40px;
    left: -50px;
    border-radius: 100px;
    background: #fff;
    cursor: pointer;
    font-size: 25px;
    &.is-icon{
      width: 100px;
    }
    &:hover{
      @include active
    }
  }
  .el-step__line-inner{
    border-color: $line;
  }
  .el-step__line{
    background-color: $line;
  }
  .el-step__head{
    color: #333;
    &.is-process{
      .el-step__icon{
        @include active
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue